module.exports = __webpack_public_path__ + "static/media/rewards.6b54ad55.svg";